import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  dropZone: {
    border: '0.25rem solid transparent',
    boxSizing: 'border-box',
    height: '1rem'
  },

  dropZoneTop: {
    borderBottomColor: 'gainsboro'
  },

  dropZoneMiddle: {
    borderTopColor: 'gainsboro',
    borderBottomColor: 'gainsboro'
  },

  dropZoneBottom: {
    borderTopColor: 'gainsboro'
  },

  root: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.size.sm
  },

  dragPreview: {
    flex: 1,
    display: 'flex',
    alignItems: 'center'
  },

  dragHandle: {
    display: 'flex',
    alignItems: 'center'
  },

  name: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 'auto'
  },

  dragIcon: {
    marginRight: '0.5rem',
    cursor: 'pointer'
  },

  closeIcon: {
    cursor: 'pointer'
  },

  fieldIcon: {
    marginRight: '0.5rem'
  }
}))

export default useStyles
